import requestMiddlewareGenerator from 'global/lib/api/requestMiddleware'

export default requestMiddlewareGenerator()
